import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs/Observable';
import { publishReplay, refCount } from 'rxjs/operators';
import { Employment } from '../../models/customer.model';
import { HttpClientService } from '../httpClient/httpclient.service';

@Injectable()
export class EmploymentService {

  private baseUrl = 'koncentro-customers';
  employments: Employment[];
  employmentEditing: Employment;
  private cachedFields: Observable<any>;

  constructor (
    private http: HttpClientService,
    private srvNotify: MessageService
  ) { }

  getAll(): Observable<Array<Employment>> {
    return this.http.get('/' + this.baseUrl + '/employments');
  }

  getList() {
    return this.http.get('/' + this.baseUrl + '/employments')
      .map(res => {
        return this.employments = res;
      });
  }

  delete(record) {
    return this.http.delete('/' + this.baseUrl + '/employments/' + record.id)
      .map(res => {
        this.employments.splice(this.employments.indexOf(record), 1);
        this.srvNotify.add({severity: 'info', summary: 'Confirmed', detail: 'Employment deleted'});
      });
  }

  post(newData) {
    return this.http.post('/' + this.baseUrl + '/employments', newData)
      .map(res => {
        newData.id = res.id;
        this.employments.push(newData);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });

  }

  put(newData, id) {
    return this.http.put('/' + this.baseUrl + '/employments/' + id, newData)
      .map(res => {
        Object.assign(this.employmentEditing, newData);
        this.srvNotify.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.http.get('/koncentro-customers/schema/EmploymentDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/employment/employment.service.ts